import { log } from "@qgiv/core-js";
import { sendRequestForCardToken } from "./sendRequestForCardToken";

/**
 * @typedef {import("./paymentIframeTypes").CardTokenErrorResponse} CardTokenErrorResponse
 * @typedef {import("./paymentIframeTypes").CardTokenSuccessResponse} CardTokenSuccessResponse
 * @typedef {import("./paymentIframeTypes").ParsedErrorResponseFromPaymentIframe} ParsedErrorResponseFromPaymentIframe
 * @typedef {import("./paymentIframeTypes").ParsedSuccessResponseFromPaymentIframe} ParsedSuccessResponseFromPaymentIframe
 */

/**
 *
 * @returns {CardTokenSuccessResponse}
 */
const getDataThatEnablesSubmission = () => {
    const data = {
        validationErrors: {},
        success: true,
        token: "",
    };

    return data;
};

/**
 *
 * @param {ParsedErrorResponseFromPaymentIframe|ParsedSuccessResponseFromPaymentIframe} response
 * @returns {CardTokenErrorResponse|CardTokenSuccessResponse}
 */
const getDataFromResponse = (response) => {
    const { data } = response;

    return data;
};

/**
 *
 * @description Retrieves the appropriate card token value that we will need
 * during submission by returning an empty string if we don't need a card token
 * and initiating communication with the payment iframe if we do need a token.
 * @param {string} urlOfPaymentIframe
 * @param {boolean} requiresCardTokenFromPaymentIframe
 * @returns {Promise<string>}
 */
export const getCardToken = (
    urlOfPaymentIframe,
    requiresCardTokenFromPaymentIframe,
) => {
    const cardToken = new Promise((resolve, reject) => {
        const dataThatEnablesSubmission = getDataThatEnablesSubmission();

        /**
         * @description Handles responses that contain a valid card token and
         * those that contain FE CC validation errors.
         * @param {ParsedSuccessResponseFromPaymentIframe} response
         * @returns {void}
         */
        const handleSuccess = (response) => {
            log(
                "HOST APPLICATION: RECEIVE POST MESSAGE RESPONSE FROM PAYMENT APP WITH NEW CARD TOKEN OR PAYMENT IFRAME VALIDATION ERRORS",
            );
            log({
                response,
            });
            const data = getDataFromResponse(response);
            resolve(data);
        };

        /**
         * @description Handles responses that contain a card token error that
         * are thrown by the tokenize payment API.
         * @param {ParsedErrorResponseFromPaymentIframe} response
         * @returns {void}
         */
        const handleError = (response) => {
            log(
                "HOST APPLICATION: RECEIVE POST MESSAGE RESPONSE FROM PAYMENT APP WITH ERRORS FROM API RESPONSE OR VALIDATEFORM",
            );
            const data = getDataFromResponse(response);
            reject(data);
        };

        if (!requiresCardTokenFromPaymentIframe) {
            resolve(dataThatEnablesSubmission);
        } else {
            sendRequestForCardToken(urlOfPaymentIframe)
                .then(handleSuccess)
                .catch(handleError);
        }
    });

    return cardToken;
};
